import { createMiddleware } from "@tanstack/react-start";

// Lazy variant of attachSupabaseAuth.
//
// The generated `auth-attacher.ts` statically imports the full supabase-js
// client, which forces the entire supabase chunk (auth, realtime, storage,
// postgrest, phoenix ≈ 53 KiB) into the main entry bundle and gets it
// modulepreloaded on every page — including the homepage, where none of it is
// used. Importing the client dynamically inside the middleware body keeps it in
// its own chunk that only loads when a server function actually runs on the
// client, removing it from the critical initial-load path.
export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    try {
      const { supabase } = await import("./client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      if (token) {
        return next({ headers: { Authorization: `Bearer ${token}` } });
      }
    } catch {}
    return next();
  },
);